
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[partnerId]/product/[productId]",
      function () {
        return require("private-next-pages/[partnerId]/product/[productId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[partnerId]/product/[productId]"])
      });
    }
  